import React from 'react'
import MyAccessHome from '../images/MyAccess_1.png'
import ManageMyAccess from '../images/MyAccess_2.png'
import GoPayRoleRequest from '../images/gopay_role_request.png'
import { Message } from '@paypalcorp/worldready-react'
import { constants } from '../constants/constants'

function AccessDenied({ user, roleToRequest, isCOC }) {
  const isGoPayUser = user.accType === constants.GoPayUser

  const localizationIdPrefix = isGoPayUser
    ? 'accessDenied.requestAccess.gopay'
    : 'accessDenied.requestAccess'
  return (
    <div className="access__denied-container ppvx_text--lg">
      <div className="access__denied-content-main">
        <h2 className="access__denied-header flexCenter">
          <Message id="accessDenied.header" />
        </h2>
        <div className="access__denied-content flexCenter">
          <div className="access__denied-user-info">
            <Message
              id="accessDenied.noAccess"
              displayname={user.displayname}
            />
          </div>
          <div className="access__denied-steps">
            <ul className="access__denied-steps-list">
              <li>
                <span className="ppvx_text--lg">
                  <Message
                    id={`${localizationIdPrefix}.step1`}
                    link={(innerMessage) => (
                      <a
                        href="https://myaccess.paypalinc.com/identityiq/home.jsf"
                        rel="noopener noreferrer"
                        target="_blank"
                      >
                        {innerMessage}
                      </a>
                    )}
                  />
                </span>
              </li>
              <li>
                <span className="ppvx_text--lg">
                  <Message id={`${localizationIdPrefix}.step2`} />
                </span>
              </li>
              <li>
                <span className="ppvx_text--lg">
                  <Message
                    id={`${localizationIdPrefix}.step3`}
                    role={roleToRequest}
                    bold={(innerMessage) => (
                      <b className="access__user">{innerMessage}</b>
                    )}
                  />
                </span>
              </li>
              <li>
                <span className="ppvx_text--lg">
                  <Message
                    id={`${localizationIdPrefix}.step4`}
                    role={roleToRequest}
                    bold={(innerMessage) => (
                      <b className="access__user">{innerMessage}</b>
                    )}
                  />
                </span>
              </li>
              <li>
                <span className="ppvx_text--lg">
                  <Message id={`${localizationIdPrefix}.step5`} />
                </span>
              </li>
              <li>
                <span className="ppvx_text--lg">
                  <Message id={`${localizationIdPrefix}.step6`} />
                </span>
                {!isGoPayUser && (
                  <span className="access__approvers">
                    (DL-PayPal-DropZone-Support)
                  </span>
                )}
              </li>
            </ul>
          </div>
          {!isCOC && (
            <>
              {isGoPayUser ? (
                <div className="image__container">
                  <div>
                    {' '}
                    <img
                      className="image2"
                      src={GoPayRoleRequest}
                      alt="GoPayRoleRequest"
                    />
                  </div>
                </div>
              ) : (
                <div className="image__container">
                  <div>
                    {' '}
                    <img
                      className="image1"
                      src={MyAccessHome}
                      alt="MyAccessHome"
                    />
                  </div>
                  <div>
                    {' '}
                    <img
                      className="image2"
                      src={ManageMyAccess}
                      alt="ManageMyAccess"
                    />
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default AccessDenied
